export const max = len => `@media (max-width: ${len}px)`;
export const min = len => `@media (min-width: ${len}px)`;
export const lastOfType = () => `&:last-of-type`;
export const firstOfType = () => `&:first-of-type`;



// WEBPACK FOOTER //
// ./utils/CssUtils.js